module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/2_51525f22d91b33a3e04545cff396078f.png";